import {SERVER} from '../../config/server.config';
import {requestData} from "../../config/services/datasets";
import { Dispatch } from 'redux';
import { AboutAction, AboutType } from '../types';

export const updateAbout = (data:AboutType) => {
  return {
    type: AboutAction.UPDATE_ABOUT,
    AboutData: data,
  };
};

export const getAboutData = () => {
  return async (dispatch: Dispatch) => {
    const results = await requestData(SERVER.ABOUT_DATA());
    // const results = aboutJson.results;
    if (results) {
      dispatch(updateAbout(results[0]));
    }
  };
};
